<template>
    <div class="dinamic-test-input dinamic-test-input-array text-center" v-show="isShowing">
        <div v-if="isEmpty(item)"></div>
        <div v-if="isBoolean(item)">
            <toggle-button v-model="item.answer" :width="60" :height="30" :disabled="isDisabled" :labels="{checked: 'Yes', unchecked: 'No'}" :sync="true"></toggle-button>
        </div>
        <div v-if="isBooleanResult(item)">
            <span v-if="item.answer" class="text-success bold" :class="{'text-muted' : isDisabled}">Yes</span>
            <span v-else class="text-danger bold" :class="{'text-muted' : isDisabled}">No</span>
        </div>
        <div v-if="isString(item) || isPercentageInput(item)">
            <input type="text" v-model="item.answer" :disabled="isDisabled" class="form-control text-center" >
        </div>
        <div v-if="isTextarea(item)">
            <textarea type="text" v-model="item.answer" :disabled="isDisabled" :placeholder="item.placeholder" class="form-control" style="resize: none"></textarea>
        </div>
        <div v-if="isNumber(item)">
            <vue-numeric v-model="item.answer" :disabled="isDisabled" class="form-control text-center"></vue-numeric>
        </div>
        <div v-if="isDouble(item)">
            <vue-numeric v-model="item.answer" :disabled="isDisabled" :precision="2" class="form-control text-center"></vue-numeric>
        </div>
        <div v-if="isPercentage(item)" :class="{'text-muted' : isDisabled}">
            <span v-text="convertToPercentage(item.answer)"></span>
        </div>
        <div v-if="isStringResult(item)" :class="{'text-muted' : isDisabled}">
            <span v-text="item.answer"></span>
        </div>
        <div v-if="isOption(item)">
            <select v-model="item.answer" :id="inputId" :class="{'text-muted' : isDisabled}" :disabled="isDisabled" class="form-control text-center">
                <option value="">Select...</option>
                <option v-for="option in item.options" :value="option" :key="option" v-text="option"></option>
            </select>
        </div>
    </div>
</template>
<script>

    let DinamicTestInputs = require('@/mixins/Forms/DinamicTestInputs')

    export default {

        mixins: [DinamicTestInputs],

        props: {
            item: {
                type: Object,
                required: true,
            },
            broadcast: {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        data(){
            return {
                input: this.item,
            }
        },
        //
        // watch: {
        //     item: {
        //         deep: true,
        //         // handler(value) {
        //             // this.input = value;
        //             // if (this.broadcast) {
        //             //     this.broadcastAnswer(value.answer)
        //             // }
        //         }
        //     }
        // },
        //
        // methods:{
        //     broadcastAnswer(answer){
        //         // axios.post(`/api/broadcasat-answer`, {
        //         //     test_id: this.testId,
        //         //     answer: t
        //         // })
        //     }
        // },

        computed: {

            isDisabled() {
                if (this.item.hasOwnProperty('disabled')) {
                    return this.item.disabled;
                }
                return false;
            },

            isShowing(){
                if (this.item.hasOwnProperty('display')) {
                    return this.item.display;
                }
                return true;
            }
        }

    }
</script>
